module.exports = __webpack_public_path__ + "img/map-step_6.5d038aa.webp";